import { IconWrap, MessagesBubbleSquareTextIcon, Tooltip } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import type { RestModel } from '@spa/scenes/Plannings/redux/models/Rest'
import type { FC } from 'react'
import React from 'react'

import { CardFooter } from '../../Card'

type Props = {
  rest: RestModel
}

const RestNote: FC<Props> = ({ rest }) => {
  const { t } = usePlanningTranslation()

  if (!rest?.note) {
    return null
  }

  return (
    <CardFooter.ActionItem>
      <Tooltip
        data-testid='rest-note'
        label={t('weekly.card.note', { note: rest.note })}
        className='flex items-center'
      >
        <div className='flex items-center'>
          <IconWrap icon={<MessagesBubbleSquareTextIcon />} size='s' />
        </div>
      </Tooltip>
    </CardFooter.ActionItem>
  )
}

export default RestNote
